<aside class="sidebar" [class.collapsed]="isCollapsed()">
    <div class="nav-content">
        @for (group of navGroups; track group.id) {
            <div class="nav-group" role="group" [attr.aria-label]="group.label">
                <!-- TailAdmin section header; collapses to a ••• divider. -->
                <div class="group-label" aria-hidden="true">
                    <span class="group-label-text">{{ group.label }}</span>
                    <span class="group-label-dots">•••</span>
                </div>
                @for (item of group.items; track item.id) {
                    <button
                        class="nav-button"
                        [class.collapsed]="isCollapsed()"
                        [routerLink]="item.route"
                        [routerLinkActive]="item.route ? 'active' : ''"
                        [matTooltip]="item.label"
                        [matTooltipDisabled]="!isCollapsed()"
                        matTooltipPosition="right"
                    >
                        <mat-icon class="icon">{{ item.icon }}</mat-icon>
                        <span class="nav-text">{{ item.label }}</span>
                        @if (item.badge) {
                            <span class="nav-badge">{{ item.badge }}</span>
                        }
                    </button>
                }
            </div>
        }
    </div>

    <div class="toggle-container">
        <button
            class="toggle-btn"
            (click)="toggleSidebar()"
            [disabled]="isToggleDisabled()"
            [attr.aria-label]="
                isCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'
            "
        >
            <mat-icon>{{
                isCollapsed() ? "chevron_right" : "chevron_left"
            }}</mat-icon>
        </button>
    </div>
</aside>
